import { Component, ElementRef, OnInit } from '@angular/core';

/**
 * @ignore
 */
@Component({
  selector: 'uex-card-body',
  templateUrl: './body.component.html',
  host: {
    class: 'uex-card-body card-body'
  }
})
export class CardBodyComponent implements OnInit {
  constructor(
    public elementRef: ElementRef
  ) { }

  ngOnInit() { }
}
